import { TechnicalSentimentChart } from "./chart/TechnicalSentimentChart";
import { TimeFrames } from "../../../types";
import { TimeFramesPanel } from "./timeframes/Timeframes";
import { TechnicalAnalysisData } from "../../hooks/useSymbolTechnicalAnalysis";
import styles from "./TechnicalSentiment.module.scss";

type TechnicalSentiment = TechnicalAnalysisData["technicalSentiment"];

interface ITechnicalSentimentProps {
    ticker: string;
    data: any;
    timeFrame: TimeFrames;
    setTimeFrame: (timeFrame: TimeFrames) => void;
}

export const TechnicalSentiment = ({
    data,
    timeFrame,
    setTimeFrame,
    ticker,
}: ITechnicalSentimentProps) => {
    const { technicalSentiment } = data;
    const macd = data?.indicators?.find(i => i.name.includes("MACD macd"));
    const sentence = `(${ticker}) Moving Averages Convergence Divergence 
    (MACD) indicator is ${macd?.value.toFixed(2)}, suggesting Apple is a ${macd?.action}.`;

    return (
        <div className={styles.technicalSentiment}>
            <TimeFramesPanel onChange={setTimeFrame} selected={timeFrame} />
            <div className={styles.charts}>
                <TechnicalSentimentChart title="Overall Consensus" data={technicalSentiment?.summary} />
                <TechnicalSentimentChart
                    title="Technical Analysis Consensus"
                    data={technicalSentiment?.oscillators}
                />
                <TechnicalSentimentChart
                    title="Moving Average Consensus"
                    data={technicalSentiment?.movingAverages}
                />
            </div>
            <div className={styles.chartsInfo}>
                <ul>
                    <li>{sentence}</li>
                </ul>
            </div>
        </div>
    );
};
